type Props = {
	className?: string
}

export const ArrowIcon = ({ className }: Props) => {
	return (
		<svg
			className={className}
			width="10"
			height="10"
			viewBox="0 0 10 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.75 0.75H9.08333M9.08333 0.75V9.08333M9.08333 0.75L0.75 9.08333"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
